import Vue from 'vue'

const ADRESS_SET_STREET =(state, payload)=> {
            
    state.data.street = payload
};

const ADRESS_SET_ZIP =(state, payload)=> {
            
    state.data.zip = payload
};

const ADRESS_SET_CITY =(state, payload)=> {
            
    state.data.city = payload
};
const ADRESS_SET_COUNTRY =(state, payload)=> {
            
    state.data.country = payload
};

const ADRESS_SET_LATITUDE =(state, payload)=> {
            
    state.data.latitude = payload
};

const ADRESS_SET_LONGITUDE =(state, payload)=> {
            
    state.data.longitude = payload
};

const ADRESS_SET_ADRESSES =(state, payload)=> {

        state.adresses=payload
};

const ADRESS_SET_ADRESS =(state, payload)=> {

        state.data.street=payload.street
        state.data.zip=payload.zip
        state.data.city=payload.city
        state.data.country=payload.country
        state.data.latitude=payload.latitude
        state.data.longitude=payload.longitude

};

const ADRESS_INIT_ADRESS =(state)=> {

        state.data.street=""
        state.data.zip=""
        state.data.city=""
        state.data.country=""
        state.data.latitude=0
        state.data.longitude=0

};

export default {
    ADRESS_SET_STREET,
    ADRESS_SET_ZIP,
    ADRESS_SET_CITY,
    ADRESS_SET_COUNTRY,
    ADRESS_SET_LATITUDE,
    ADRESS_SET_LONGITUDE,
    ADRESS_SET_ADRESSES,
    ADRESS_SET_ADRESS,
    ADRESS_INIT_ADRESS
};